import { render, staticRenderFns } from "./GachaMachine.vue?vue&type=template&id=57bdc1e0&scoped=true"
import script from "./GachaMachine.vue?vue&type=script&lang=js"
export * from "./GachaMachine.vue?vue&type=script&lang=js"
import style0 from "./GachaMachine.vue?vue&type=style&index=0&id=57bdc1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bdc1e0",
  null
  
)

export default component.exports